<template>
  <div>
    <v-container>
      <v-row class="justify-center">
        <!--Card-->
        <v-col cols="12" md="7">
          <v-card class="mb-3 pa-4" outlined>
            <!--Card title-->
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="8" style="font-size: 18px; font-weight: 500;"
                >Osnovni podaci</v-col
              >
            </v-row>
            <!--Card body-->
            <v-row
              v-for="(value, propertyName, index) in departmentData"
              :key="index"
            >
              <v-col cols="4" class="d-flex justify-end">
                <p class="font-weight-light mb-0">{{ propertyName }}:</p>
              </v-col>
              <v-col>
                <p
                  v-if="value.link !== ''"
                  class="mb-0"
                  style="font-weight: 500;"
                >
                  <router-link style="text-decoration: none;" :to="value.link">
                    {{ value.name ? value.name : "-" }}
                  </router-link>
                </p>
                <p v-else class="mb-0" style="font-weight: 500;">
                  {{ value.name ? value.name : "-" }}
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!--Action buttons-->

        <v-col cols="12" md="3">
          <v-btn
            color="primary"
            v-if="$checkPermission('departments edit')"
            class="mb-4 text-none elevation-0"
            height="44"
            @click="showAddForm()"
            block
          >
            Uredi podatke
          </v-btn>
          <v-btn
            v-if="$checkPermission('administer department')"
            color="primary"
            class="mb-4 text-none elevation-0"
            height="44"
            @click="administerDialog = true"
            block
          >
            Administriraj odjeljenje
          </v-btn>
          <v-btn
            class="custom-btn-blue text-none"
            height="44"
            color="primary"
            @click="deleteDialog = true"
            v-if="$checkPermission('departments delete')"
            block
            outlined
          >
            Obriši odjeljenje
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title primary-title>
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text style="padding-top: 20px;">
          {{ deleteText }}
          <h3 class="pt-3 red--text">Napomena:</h3>
          <p>Kako bi mogli obrisati odjel prvo morate pobrisati sve učenike iz tog odjela.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" depressed large outlined
            >Odustani</v-btn
          >
          <v-btn
            v-if="$checkPermission('departments delete')"
            @click="deleteItem()"
            color="error"
            depressed
            large
            >Izbriši</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="administerDialog" width="600">
      <v-card>
        <v-card-title class="mb-4" primary-title>
          Administriraj odjeljenje
        </v-card-title>

        <div v-if="departmentStudents.length > 0" class="pa-2">
          <v-card-text>
            <ValidationProvider
              :name="item.name"
              :rules="item.rules"
              mode="eager"
              ref="provider"
              v-bind:key="item.name"
              v-for="item in items"
            >
              <div slot-scope="{ errors }">
                <v-row no-gutters>
                  <!--Label for the form-->
                  <v-col
                    xs="12"
                    md="3"
                    style="height: 65px"
                    class="d-flex justify-end"
                  >
                    <div
                      class="d-flex align-center justify-end text-right mb-2"
                    >
                      <p
                        class="subtitle-3 font-weight-bold text--primary"
                        :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                      >
                        {{ item.title }}:
                      </p>
                    </div>
                  </v-col>

                  <!-- Text field -->
                  <v-col xs="12" md="9" style="height: 65px">
                    <!-- Select field -->

                    <v-autocomplete
                      outlined
                      dense
                      :placeholder="item.rules ? 'Obavezno..' : ''"
                      :items="item.source"
                      :name="item.name"
                      :prepend-icon="item.icon"
                      item-text="full_name"
                      item-value="id"
                      v-if="item.tag === 'select'"
                      v-model="form[item.name]"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </div>
            </ValidationProvider>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="administerDialog = false" depressed large outlined>
              Odustani
            </v-btn>
            <v-btn color="primary" @click="editDepartment()" depressed large>
              Potvrdi
            </v-btn>
          </v-card-actions>
        </div>

        <div v-else class="pa-2">
          <v-card-text v-if="currentRole.role_id === 5">
            <p>
              Učenici moraju biti dodani u odjeljenje kako bi mogli
              administrirati odjeljenje. Obratite se školskom kooridinatoru kako
              bih unio učenike.
            </p>
          </v-card-text>
          <v-card-text v-else>
            <p>
              Morate prvo dodati učenike u odjeljenje kako bi mogli birati
              predstavnika, zamjenika i blagajnika.
            </p>
            <div class="d-flex justify-center mb-3">
              <v-btn color="primary" @click="goAddStudents()" depressed large>
                Dodajte učenike
              </v-btn>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="administerDialog = false" depressed large outlined
              >Zatvori</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { serverBus } from "../../../main";
import ApiV2 from "@/services/ApiV2";
import { extend, setInteractionMode, ValidationProvider } from "vee-validate";
import { digits, email, max, min, required } from "vee-validate/dist/rules";

export default {
  components: {
    ValidationProvider,
  },
  data() {
    return {
      loading: false,
      departmentData: {},
      deleteDialog: false,
      administerDialog: false,
      departmentId: null,
      departmentStudents: [],
      isLocked: false,
      deleteText:
        "Operacija koju ste zatražili može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?",
      dialogTitle: "Jeste li sigurni?",
      form: {},
      items: [
        {
          data: "representative_id",
          name: "representative_id",
          text: "full_name",
          options: "",
          rules: "",
          source: [],
          tag: "select",
          title: "Predstavnik",
        },
        {
          data: "deputy_representative_id",
          name: "deputy_representative_id",
          text: "full_name",
          options: "",
          rules: "",
          source: [],
          tag: "select",
          title: "Zamjenik",
        },
        {
          data: "treasurer_id",
          name: "treasurer_id",
          text: "full_name",
          options: "",
          rules: "",
          source: [],
          tag: "select",
          title: "Blagajnik",
        },
      ],
    };
  },
  created() {
    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", { ...required, message: "Ovo polje je obavezno." });

    this.departmentId = this.$route.params.odjeljenje_id;

    this.getDepartment();

    serverBus.$on("show-department-add-form", () => {
      this.$router.push({
        name: "DepartmentAddView",
        params: { table: "odjeljenje", resource_id: `${this.departmentId}` },
      });
    });
  },
  computed: {
    selectedField() {
      return this.$store.getters.getSchoolFieldId;
    },
    currentRole() {
      return this.$store.getters.getCurrentRole;
    },
  },

  methods: {
    optimizeApiData(departmentData) {
      this.departmentData = {
        "Nastavni plan": {
          name: departmentData?.school_plan?.title,
          link:
            localStorage.getItem("role_id") != 5 && localStorage.getItem("role_id") != 7
              ? `/admin/nastavni_planovi/${departmentData?.school_plan_id}`
              : "",
        },
        Naziv: { name: departmentData?.label, link: "" },
        Smjer: {
          name:
            departmentData?.school_educational_field?.educational_field?.name,
          link: "",
        },
        Razrednik: {
          name: departmentData?.headroom_teacher?.full_name,
          link: localStorage.getItem("role_id") != 7 ?
              `/admin/djelatnik/pregled/${departmentData?.headroom_teacher_id}` : "",
        },
        Predstavnik: {
          name: departmentData?.representative?.full_name,
          link: localStorage.getItem("role_id") != 7 ?
              `/admin/ucenik/pregled/${departmentData?.representative_id}` : "",
        },
        Zamjenik: {
          name: departmentData?.deputy_representative?.full_name,
          link: localStorage.getItem("role_id") != 7 ?
              `/admin/ucenik/pregled/${departmentData?.deputy_representative_id}` : "",
        },
        Blagajnik: {
          name: departmentData?.treasurer?.full_name,
          link: localStorage.getItem("role_id") != 7 ?
              `/admin/ucenik/pregled/${departmentData?.treasurer_id}` : "",
        },
      };
    },

    goAddStudents() {
      this.$router.push(
        `/admin/odjeljenje/pregled/${this.departmentId}/ucenik/dodaj`
      );
    },

    getDepartment() {
      ApiV2.get(`departments/${this.departmentId}`, {
        params: {
          with: [
            "schoolPlan",
            "users",
            "headroomTeacher",
            "representative",
            "deputyRepresentative",
            "treasurer",
            "schoolEducationalField.educationalField",
          ],
        },
      }).then((response) => {
        this.optimizeApiData(response.data);
        this.form = response.data;

        const {
          lock_enrollments,
          users,
          label,
          school_plan_id,
          school_educational_field_id,
          school_class,
          headroom_teacher_id,
        } = response.data;

        this.isLocked = lock_enrollments;

        this.departmentStudents = users;

        this.items.forEach((item) => {
          item.source = users;
        });

        this.form.label = label;
        this.form.school_plan_id = school_plan_id;
        this.form.school_educational_field_id = school_educational_field_id;
        this.form.school_class = school_class;
        this.form.headroom_teacher_id = headroom_teacher_id;
      });
    },

    deleteItem() {
      // serverBus.$emit('show-delete-item-dialog', 'odjeljenje', {id: this.$route.params.odjeljenje_id});
      ApiV2.delete(`departments/${this.$route.params.odjeljenje_id}`)
        .then(() => {
          this.dialog = false;
          this.$router.push("/admin/odjeljenje");
          serverBus.$emit("show-snackbar", true);
        })
        .catch(() => {
          serverBus.$emit(
            "show-snackbar",
            false,
            "Ne mogu izbrisati ovu stavku."
          );
        });
    },

    editDepartment() {
      ApiV2.put(`departments/${this.$route.params.odjeljenje_id}`, this.form)
        .then(() => {
          this.getDepartment();
          serverBus.$emit(
            "show-snackbar",
            true,
            "Uspješno ste ažurirali odjeljenje."
          );

          this.administerDialog = false;
        })
        .catch(() => {
          serverBus.$emit("show-snackbar", false);
        });
    },

    showAddForm: function() {
      serverBus.$emit("show-department-add-form", {
        id: this.$route.params.odjeljenje_id,
      });
    },
  },
};
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>
